import { render, staticRenderFns } from "./paramsInterfaceElement.vue?vue&type=template&id=5b44e9b0&scoped=true&"
import script from "./paramsInterfaceElement.vue?vue&type=script&lang=js&"
export * from "./paramsInterfaceElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44e9b0",
  null
  
)

export default component.exports